module.exports = "/_next/static/images/il-033c38c0d792b6f0031e44693de50798.svg";